import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'antd/dist/reset.css';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from 'react-router-dom';
import routes from './routes/index.js';
import { Provider } from "react-redux";
import store from "./reducers/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import FunctionalErrorBoundary from './components/ErrorBoundary.js';
import { AuthProvider } from './contexts/AuthContext';
import AppWrapper from './components/AppWrapper';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <FunctionalErrorBoundary>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <AppWrapper>
                <RouterProvider router={routes} />
              </AppWrapper>
            </AuthProvider>
          </QueryClientProvider>
        </Provider>
      </GoogleOAuthProvider>
    </FunctionalErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();